import format from 'format-number'
import domtoimage from 'dom-to-image'
import _ from 'lodash'
import totalCostsSum from '../../../../../../../../calculations/totalCosts/sum'
import averageMonthlyCostByAge from '../../../../../../../../calculations/averageMonthlyCostByAge'
import annualCostsByAge from '../../../../../../../../calculations/annualCostsByAge'

const formatter = format({ prefix: '$', round: 0 })

const toBlob = (selector) => (
  domtoimage.toPng(document.querySelector(selector))
)

export default (sendResults, form, handleSuccess) => async (variables) => {
  await sendResults({
    body: JSON.stringify({
      ...variables,
      totalCosts: formatter(totalCostsSum(form)),
      totalCostsChart: await toBlob('#export-total-costs-chart'),
      averageAnnualCosts: formatter(_.meanBy(annualCostsByAge(form), 'value')),
      averageAnnualCostsChart: await toBlob('#export-average-annual-costs-chart'),
      averageMonthlyCosts: formatter(_.meanBy(averageMonthlyCostByAge(form), 'value')),
      averageMonthlyCostsChart: await toBlob('#export-average-monthly-costs-chart'),
    }),
  })

  handleSuccess()
}
